import React from 'react';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { CookbookInputWrapper } from 'src/components/CookbookInputWrapper/CookbookInputWrapper';
import { LETTERS_AND_SPACES_REGEX } from 'src/utilities/regexPatterns';

export interface ExpenseCodeProps {
  name: string;
  id: string;
}

export function ExpenseCode({ name, id }: ExpenseCodeProps): JSX.Element {
  const { errors, control } = useFormContext();

  const isEmptyValue = (value: string): boolean | string =>
    value.trim() !== '' || 'A term must be provided';

  return (
    <CookbookInputWrapper
      name={name}
      id={id}
      control={control}
      error={errors[name]}
      maxLength={30}
      inputSize="medium"
      blockWidth
      label="What terminology is used for expense codes? Use the singular form. *"
      rules={{
        required: 'A term must be provided',
        pattern: {
          value: LETTERS_AND_SPACES_REGEX,
          message: 'Only alphabetical characters may be used.',
        },
        validate: {
          isEmpty: isEmptyValue,
        },
      }}
    />
  );
}
